/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Home_About_Body1Inputs */

const ja_playdata_home_about_body1 = /** @type {(inputs: Playdata_Home_About_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`独自に取得したライブストリーミング配信のデータに基づき、国内のメジャーなeスポーツ大会のイベントデータを幅広く保持しています。`)
};

const en_playdata_home_about_body1 = /** @type {(inputs: Playdata_Home_About_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`With a wealth of streaming data related to domestic Japanese esports and games, PLAYDATA provides comprehensive insights from all angles.`)
};

/**
* | output |
* | --- |
* | "With a wealth of streaming data related to domestic Japanese esports and games, PLAYDATA provides comprehensive insights from all angles." |
*
* @param {Playdata_Home_About_Body1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_home_about_body1 = /** @type {((inputs?: Playdata_Home_About_Body1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Home_About_Body1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_home_about_body1(inputs)
	return en_playdata_home_about_body1(inputs)
});